<template>
  <section>
    <app-loading v-if="loading" />

    <div v-else>
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex">
        </div>
      </div>
      <!-- END: Filter -->

      <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
        <table class="table table-report -mt-2">
          <thead>
              <tr>
                  <th class="text-center whitespace-no-wrap">NOMBRE</th>
                  <th class="text-center whitespace-no-wrap">CORREO</th>
                  <th class="text-center whitespace-no-wrap">EQUIPO</th>
                  <th class="text-center whitespace-nowrap">ACTIVIDAD</th>
                  <th class="text-center whitespace-nowrap">ACCIONES</th>
              </tr>
          </thead>
          <tbody>
            <tr class="intro-x">
              <td class="Text-center">
                <div class="text-center text-gray-600 text-xs whitespace-no-wrap">
                  {{ activity.user.name }}
                </div>
              </td>
              <td>
                <div class="text-center text-gray-600 text-xs whitespace-no-wrap">
                  {{ activity.user.email }}
                </div>
              </td>
              <td>
                <div class="text-center text-gray-600 text-xs whitespace-no-wrap">
                  {{ activity.user.team ? activity.user.team.name : '-' }}
                </div>
              </td>
              <td class="w-40">
                <div class="text-center text-gray-600 text-xs whitespace-no-wrap">
                  {{ activity.activity.name }}
                </div>
              </td>
              <td class="table-report__action w-56">
                <div class="flex">
                  <router-link :to="`/admin/activities/${activity.activity.slug}/participations`"
                    class="flex mx-auto items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                    Regresar
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- List -->
      <div class="overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="text-center whitespace-no-wrap">PREGUNTA</th>
              <th class="text-center whitespace-no-wrap">RESPUESTA</th>
            </tr>
          </thead>
          <tbody>
            <tr class="intro-x" v-for="answer in activity.answers" :key="`activity-${answer.slug}`">
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap" v-if="answer.question">
                  {{ answer.question.title }}
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap"
                  :class="answer.is_correct ? 'text-green-400' : 'text-red-400'" v-if="answer.question_answer">
                  {{ answer.question_answer.text_answer }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->
    </div>
  </section>
</template>

<script>
  import { mapActions } from 'vuex'
  import Icon from '@/components/admin/partials/Icon'
  import Loading from '@/components/admin/partials/LoadingWhite'

  export default {
    name: 'ListUserAnswers',
    data () {
      return {
        loading: false,
        activity: {},
      }
    },
    async beforeMount () {
      this.loading = true
      try {
        const { model } = await this.get(`/activity/${this.$route.params.slug}/answers`)
        console.log(model)
        this.activity = model
      } catch (error) {
        this.$router.push('/admin/activities')
      } finally {
        this.loading = false
      }
    },
    methods: {
      ...mapActions([
        'get'
      ])
    },
    components: {
      appIcon: Icon,
      appLoading: Loading,
    },
  }
</script>



// WEBPACK FOOTER //
// ListUserAnswers.vue?4715730c